import { fetchFluidViscosity, resetFluidTab, setAverageCombinedSpGr, setBopd, setBottomHoleTemp, setBubblePoint, setBwpd, setFluidTabDetails, setFluidViscosity, setFluidViscosityChangeMessage, setGLR, setGOR, setGasAvailability, setGasCompressibility, setGasProduction, setHiddenAutoGasCompress, setHiddenBubblePoint, setHiddenGasIp, setHiddenOilIPType, setLiquidPhaseCombinedSpGr, setOilAPI, setOilCut, setOperatingFrequency, setRegion, setRegionList, setSelectedRegion, setGetSelectedRegion, setSpGrGas, setSpGrOil, setSpGrWater, setSurfaceTemperature, setWaterCut } from '../../../store/jetlift/jetlift-input/FluidSlice';
import { useAppDispatch } from '../../../store/hooks/StoreHooks';

const useJetliftFluidFacade = () => {
    const dispatch = useAppDispatch();

    const getFluidDetails = (payload: any) => {
        return dispatch(setFluidTabDetails(payload));
    };

    const updateSpGrWater = (payload: number) => {
        return dispatch(setSpGrWater(payload));
    };

    const updateWaterCut = (payload: number) => {
        return dispatch(setWaterCut(payload));
    };

    const updateBwpd = (payload: number) => {
        return dispatch(setBwpd(payload));
    };

    const updateOilAPI = (payload: number) => {
        return dispatch(setOilAPI(payload));
    };

    const updateSpGrOil = (payload: number) => {
        return dispatch(setSpGrOil(payload));
    };

    const updateOilCut = (payload: number) => {
        return dispatch(setOilCut(payload));
    };

    const updateBopd = (payload: number) => {
        return dispatch(setBopd(payload));
    };

    const updateAverageCombinedSpGr = (payload: number) => {
        return dispatch(setAverageCombinedSpGr(payload));
    };

    const updateLiquidPhaseCombinedSpGr = (payload: number) => {
        return dispatch(setLiquidPhaseCombinedSpGr(payload));
    };

    const updateFluidViscosity = (payload: number) => {
        if (payload === 0) {
            dispatch(setFluidViscosity(payload));
            return dispatch(fetchFluidViscosity());
        }
        return dispatch(setFluidViscosity(payload === 0 ? "" : payload)); 
    };

    const updateGasProduction = (payload: number | string | null) => {
        return dispatch(setGasProduction(payload));
    };

    const updateGOR = (payload: string | number | null) => {
        return dispatch(setGOR(payload));
    };

    const updateGLR = (payload: number | string | null) => {
        return dispatch(setGLR(payload));
    };

    const updateSpGrGas = (payload: number) => {
        return dispatch(setSpGrGas(payload));
    };

    const updateGasCompressibility = (payload: number | string | null) => {
        return dispatch(setGasCompressibility(payload));
    };

    const updateBubblePoint = (payload: number | string | null) => {
        return dispatch(setBubblePoint(payload));
    };

    const updateBottomHoleTemp = (payload: number) => {
        return dispatch(setBottomHoleTemp(payload));
    };

    const updateSurfaceTemp = (payload: number) => {
        return dispatch(setSurfaceTemperature(payload));
    };

    const updateRegion = (payload: string) => {
        return dispatch(setRegion(payload));
    };

    const updateRegionList = (payload: string) => {
        return dispatch(setRegionList(payload));
    };

    const updateSelectedRegion = (payload: string) => {
        return dispatch(setSelectedRegion(payload));
    };
    const updatedGetSelectedRegion = (payload: any) => {
        return dispatch(setGetSelectedRegion(payload));
    };
    const updateOperatingFrequency = (payload: number) => {
        return dispatch(setOperatingFrequency(payload));
    };

    const updateGasAvailability = (payload: string) => {
        return dispatch(setGasAvailability(payload));
    };

    const updateHiddenGasIp = (payload: string) => {
        return dispatch(setHiddenGasIp(payload));
    };

    const updateHiddenOilIpType = (payload: string) => {
        return dispatch(setHiddenOilIPType(payload));
    };

    const updateHiddenAutoGasComprss = (payload: string) => {
        return dispatch(setHiddenAutoGasCompress(payload));
    };

    const updateHiddenBubblePoint = (payload: string) => {
        return dispatch(setHiddenBubblePoint(payload));
    };

    const updateFluidVisMessage = (payload: string) => {
        return dispatch(setFluidViscosityChangeMessage(payload));
    };

    return {
        getFluidDetails,
        updateSpGrWater,
        updateWaterCut,
        updateBwpd,
        updateOilAPI,
        updateSpGrOil,
        updateOilCut,
        updateBopd,
        updateAverageCombinedSpGr,
        updateLiquidPhaseCombinedSpGr,
        updateFluidViscosity,
        updateGasProduction,
        updateGOR,
        updateGLR,
        updateSpGrGas,
        updateGasCompressibility,
        updateBubblePoint,
        updateBottomHoleTemp,
        updateSurfaceTemp,
        updateRegion,
        updateRegionList,
        updateSelectedRegion,
        updateOperatingFrequency,
        updateGasAvailability,
        updateHiddenGasIp,
        updateHiddenBubblePoint,
        updateHiddenAutoGasComprss,
        updateHiddenOilIpType,
        updateFluidVisMessage,
        updatedGetSelectedRegion
    };
};

export default useJetliftFluidFacade;
